import { bugNotif } from "../../api/bugsnag";
import { getErrorMsg } from "../../utils/common";

declare const fbq: (
  action: string,
  event: string,
  data: Record<string, unknown>,
  options?: { eventID?: string }
) => void;

export const generateFbqEventId = () =>
  Math.random().toString(36).substring(2, 17);

export const sendFbqInitiateCheckout = async (
  tierName: string,
  tierPrice: number,
  tierProductId: string
) => {
  try {
    fbq(
      "track",
      "InitiateCheckout",
      {
        content_name: tierName,
        content_type: "product",
        value: tierPrice,
        currency: "AUD",
        content_ids: [tierProductId],
      },
      { eventID: generateFbqEventId() }
    );
  } catch (error) {
    console.log("error sendFbqInitiateCheckout", error);
    bugNotif("sendFbqInitiateCheckout", getErrorMsg(error).rawErrorMsg);
  }
};

export const sendFbqLead = async () => {
  try {
    fbq(
      "track",
      "Lead",
      {
        content_name: "Email Signup",
        content_category: "Membership",
      },
      { eventID: generateFbqEventId() }
    );
  } catch (error) {
    console.log("error sendFbqLead", error);
    bugNotif("sendFbqLead", getErrorMsg(error).rawErrorMsg);
  }
};

export const sendFbqAddPaymentInfo = async (
  tierName: string,
  tierPrice: number,
  tierProductId: string
) => {
  try {
    fbq(
      "track",
      "AddPaymentInfo",
      {
        content_name: tierName,
        content_type: "product",
        value: tierPrice,
        currency: "AUD",
        content_ids: [tierProductId],
      },
      { eventID: generateFbqEventId() }
    );
  } catch (error) {
    console.log("error sendFbqAddPaymentInfo", error);
    bugNotif("sendFbqAddPaymentInfo", getErrorMsg(error).rawErrorMsg);
  }
};

export const sendFbqCompleteRegistration = async (
  tierName: string,
  tierPrice: number,
  tierProductId: string
) => {
  try {
    fbq(
      "track",
      "CompleteRegistration",
      {
        content_name: tierName,
        status: "complete",
        value: tierPrice,
        currency: "AUD",
        content_ids: [tierProductId],
      },
      { eventID: generateFbqEventId() }
    );
  } catch (error) {
    console.log("error sendFbqCompleteRegistration", error);
    bugNotif("sendFbqCompleteRegistration", getErrorMsg(error).rawErrorMsg);
  }
};
